/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seller: NonNullable<unknown> }} Withdrawal_Dialog_BodyInputs */

const en_withdrawal_dialog_body = /** @type {(inputs: Withdrawal_Dialog_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`You are telling ${i?.seller} that you withdraw from your contract for this purchase. You do not have to give a reason.`)
};

const pl_withdrawal_dialog_body = /** @type {(inputs: Withdrawal_Dialog_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Informujesz sprzedawcę (${i?.seller}), że odstępujesz od umowy dotyczącej tego zakupu. Nie musisz podawać powodu.`)
};

/**
* | output |
* | --- |
* | "You are telling {seller} that you withdraw from your contract for this purchase. You do not have to give a reason." |
*
* @param {Withdrawal_Dialog_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const withdrawal_dialog_body = /** @type {((inputs: Withdrawal_Dialog_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Withdrawal_Dialog_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_withdrawal_dialog_body(inputs)
	return en_withdrawal_dialog_body(inputs)
});